import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "핵심 개념",
  "description": "Turborepo의 핵심 개념에 대해 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo의 핵심 개념에 대해 자세히 알아봅니다:"
  }],
  "headings": []
};
import {Card, Cards} from '#components/card';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Turborepo의 핵심 개념에 대해 자세히 알아봅니다:"
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "원격 캐싱",
        href: "/docs/core-concepts/remote-caching",
        description: "동일한 작업을 두 번 수행하지 않아 시간을 절약합니다"
      }), _jsx(Card, {
        title: "패키지 타입",
        href: "/docs/core-concepts/package-types",
        description: "애플리케이션 패키지와 라이브러리 패키지"
      }), _jsx(Card, {
        title: "내부 패키지",
        href: "/docs/core-concepts/internal-packages",
        description: "리포지토리 내부에서 코드를 쉽게 공유합니다"
      }), _jsx(Card, {
        title: "패키지 및 태스크 그래프",
        href: "/docs/core-concepts/package-and-task-graph",
        description: "Turborepo가 태스크 간의 관계를 어떻게 파악하는지 알아봅니다"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
